import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const AquanorPage = (props: Props): JSX.Element => {
    return (
        <S_AquanorPage className={(props.className, 'cleanmap')}>
            <CustomMapPage
                mapId={'e4df6e01-4d4c-40c4-a33a-f7046c66fa3c'}
                header={null}
                controls={null}
                onMarkerSelected={(marker) => {
                    console.log('pes', marker);
                    debugger;
                    return true;
                }}
            />
        </S_AquanorPage>
    );
};

const S_AquanorPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
    position: relative;
`;
